import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=3552149f&scoped=true&"
import script from "./FileIcon.vue?vue&type=script&lang=ts&"
export * from "./FileIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=3552149f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552149f",
  null
  
)

export default component.exports